
import api               from '@/api'
export default {
  
    methods: {
      
        async updateFiscalPrintStatus(saleId)
        {
              
              const sp       = {'sp'       :'spUpdateFiscalPrintStatus'}      
              const data     = {'type'     : 'sale','Id': saleId }
              const json     = Object.assign(data, sp);
  
              await api.post(json).then(res =>{
                if(res.status==200)
                {
              
                    console.log('Update Fiscal Print Status',res.data)
  
                }
                else if(res.status==500)
                {
                  console.log(res)
                }
                else
                {
                  console.log(res)
                }
                                    
                      
            })
          },
        
      
         
    }

}